<template>
  <div class="admin-nav">
    <normal-nav></normal-nav>
  </div>
</template>

<script>
import normalNav from './components/normalNav'
export default {
  name: 'index',
  components: {
    normalNav
  }
}
</script>
